module.exports = __webpack_public_path__ + "img/canvas-bg4.3a23cef3.png";